'use client';

import React from 'react';
import { cn } from '@/lib/utils';
import { Example } from '@/types/Example';
import BookmarkButton from './BookmarkButton';
import CopyExampleButton from './CopyExampleButton';
import ReviewButton from './ReviewButton';
import { motion } from 'motion/react';

interface CheatActionsProps {
  cheat: Example;
  fullCard: boolean;
  actions: 'all' | 'focused';
}

const CheatActions = (props: CheatActionsProps) => {
  const { cheat, actions } = props;

  const handleClick = (event: React.MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <motion.div
      key={cheat.id}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
      className={cn(
        `flex w-full shrink-0 items-center justify-end gap-1 pl-1 sm:pl-3 print:hidden`,
      )}
      onClick={handleClick}
    >
      <div className="flex items-center">
        <BookmarkButton cheat={cheat} />
        <ReviewButton cheat={cheat} />
        {actions === 'all' && <CopyExampleButton cheat={cheat} />}
      </div>
    </motion.div>
  );
};

export default CheatActions;
